import React, { Fragment } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const shortenString = (string, album) => {
  let trunc = '';
  if (string.length > 25 && album === false) {
    trunc = `${string.substring(0, 24)}...`;
    return trunc;
  } else if (string.length > 20 && album === true) {
    trunc = `${string.substring(0, 19)}...`;
    return trunc;
  } else {
    trunc = string;
  }
  return trunc;
}

const Recommendation = props => {
  return <div>
    <div className="recommendationContainer">
      <div className="recommendationItem">
        <p className="recommendedByline">You have selected</p>
        <div className="recommendationDiv">
          {/* Album image div */}
          <div className="recAlbum">
            <div style={{ backgroundImage: `url(${props.userSong.albumImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }} className="albumImg">
              {/* Conditional rendering of play/pause button + audio element OR ban icon depending on whether there is a preview URL */}
              {props.userSong.previewURL ? <div>
                <audio src={props.userSong.previewURL} id="userSongAudio" onEnded={props.handlePlaybackEnd} />
                <button className="playButton" onClick={(e) => props.playAudio(e)} id="userSong" disabled={false}>
                  {props.userSongPaused ? <FontAwesomeIcon icon="play" className="icon" /> : <FontAwesomeIcon icon="pause" className="icon" />}
                </button>
              </div> : <button className="playButton noAudio" disabled={true}><FontAwesomeIcon icon="ban" className="icon" /></button>}
            </div>
            <div className="playBar">
            </div>
          </div>
          {/* Text section */}
          <div className="recText">
            <div className="songInfo">
              <h2>{shortenString(props.userSong.songName, false)}</h2>
              <h3>
                {props.userSong.artistNames.map((artist, i) => {
                  return <span key={artist}>{artist}{((i + 1) < props.userSong.artistNames.length) && ", "}</span>
                })}
              </h3>
              <h3>
                <span className="italic"> {shortenString(props.userSong.albumName, true)} </span> ({props.userSong.albumYear})
              </h3>
            </div>
            <div className="externalLinks">
              <a href={props.userSong.externalURL} className="spotifyLink" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={['fab', 'spotify']} />
              </a>
              <button className="saveSongButton" onClick={props.saveSong} id="userSongId">
                <FontAwesomeIcon icon="plus" className="icon" />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="recommendationItem">
        <p className="recommendedByline">
          {(["a", "e", "i", "o", "u", "y"].indexOf(props.selectedGenre.substring(0, 1).toLowerCase()) > 0) ? `An` : `A`}<span className="selectedGenre">{props.selectedGenre}</span>song you might like is
        </p>
        <div className="recommendationDiv">
          <div className="recAlbum">
            {/* Album image div */}
            <div style={{ backgroundImage: `url(${props.recommendedSong.albumImg})`, backgroundSize: 'cover', backgroundPosition: 'center' }} className="albumImg">
              {/* Conditional rendering of play/pause button + audio element OR ban icon depending on whether there is a preview URL */}
              {props.recommendedSong.previewURL ? <div>
                <audio src={props.recommendedSong.previewURL} id="recommendedSongAudio" onEnded={props.handlePlaybackEnd} />
                <button className="playButton" onClick={(e) => props.playAudio(e)} id="recommendedSong" disabled={false}>
                  {props.recommendedSongPaused ? <FontAwesomeIcon icon="play" className="icon" /> : <FontAwesomeIcon icon="pause" className="icon" />}
                </button>
              </div> : <button className="playButton noAudio" disabled={true}><FontAwesomeIcon icon="ban" className="icon" /></button>}
            </div>
          </div>
          <div className="recText">
            <div className="songInfo">
              <h2>{shortenString(props.recommendedSong.songName, false)}</h2>
              <h3>{props.recommendedSong.artistNames.map((artist, i) => {
                return <span key={artist}>{artist}{((i + 1) < props.recommendedSong.artistNames.length) && ", "}</span>
              })}</h3>
              <h3>
                <span className="italic">
                  {shortenString(props.recommendedSong.albumName, true)}
                </span> ({props.recommendedSong.albumYear})
              </h3>
            </div>
            <div className="externalLinks">
              <a href={props.recommendedSong.externalURL} className="spotifyLink" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={['fab', 'spotify']} />
              </a>
              <button className="saveSongButton" onClick={props.saveSong} id="recommendedSongId">
                <FontAwesomeIcon icon="plus" className="icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button onClick={props.showModal} className="secondaryButton" id="showComparison">Compare</button>
      <button onClick={props.showModal} className="secondaryButton" id="showHistory">All songs</button>
    </div>
    <div className="recButtons">
      <button onClick={props.tryAnother} className="tryAnother">
        Try another
      </button>
      {/* <button>Compare</button>
      <button>History</button> */}
      <button onClick={props.handleReset}>Restart</button>
      {/* <button onClick={props.saveSong}>Save song</button> */}
      {/* <button onClick={props.checkLibrary}>Check library</button> */}
    </div>

  </div>;
};

export default Recommendation;
